export default __webpack_public_path__ + "static/media/try-arrow-mobile.ddafbc74.svg";